import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Heart, CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const [message, setMessage] = useState("Confirming your payment…");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("error"); setMessage("Missing payment session."); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      if (attempts.current > 15) { setState("timeout"); setMessage("Payment is taking longer than expected."); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("done"); setMessage("Feature unlocked! Taking you back…");
          const dest = localStorage.getItem("pending_feature_route") || (data.event_id ? `/e/${data.event_id}/pricing` : "/app");
          localStorage.removeItem("pending_feature_route");
          setTimeout(() => navigate(dest), 1300);
          return;
        }
      } catch (e) {}
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [navigate]);

  const Icon = state === "done" ? CheckCircle2 : (state === "error" || state === "timeout") ? XCircle : Loader2;
  return (
    <div className="min-h-screen grid place-items-center px-6" style={{ background: "#FDFBF7" }}>
      <div className="text-center max-w-md fade-up" data-testid="payment-success-page">
        <Heart size={22} className="text-[#8C9A86] mx-auto mb-6" fill="#8C9A86" />
        <div className={`w-16 h-16 rounded-full grid place-items-center mx-auto mb-6 ${state === "done" ? "bg-[#8C9A86]/15 text-[#8C9A86]" : (state === "error" || state === "timeout") ? "bg-[#C67A7A]/15 text-[#C67A7A]" : "bg-stone-100 text-stone-400"}`}>
          <Icon size={30} className={state === "checking" ? "animate-spin" : ""} />
        </div>
        <h1 className="font-serif text-3xl tracking-tight">{state === "done" ? "All set" : (state === "error" || state === "timeout") ? "Hmm…" : "Almost there"}</h1>
        <p className="text-stone-500 mt-3">{message}</p>
        {(state === "error" || state === "timeout") && (
          <button onClick={() => navigate("/app")} data-testid="back-btn" className="mt-6 rounded-full bg-[#2C2A28] text-white px-6 py-3 text-sm hover:bg-[#8C9A86] transition-colors">Back to my events</button>
        )}
      </div>
    </div>
  );
}
